import { useEffect, useState } from 'react'
import { useWorkspaceMetadata } from '../../../../../api/hooks/workspaceMetadata/useWorkspaceMetadata'
import { ScoopButton, ScoopDialog, ScoopTextField } from '../../../../ui'
import styles from './AIFilter.module.scss'

export const AIFilter = ({
    server,
    title,
    AIFiltersDialogOpen,
    setAIFiltersDialogOpen,
    selectedInbox,
    dialogSelectedFilters,
    setDialogSelectedFilters,
}) => {
    const [filterPrompt, setFilterPrompt] = useState(null)
    const [filterName, setFilterName] = useState('')
    const [filterResult, setFilterResult] = useState()
    const [fieldList, setFieldList] = useState(null)
    const { saveFilter, saveFilterPending } = useWorkspaceMetadata()
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        let newFieldList = []
        // Add safety check for tables and columns
        if (selectedInbox?.tables?.[0]?.columns?.length > 0) {
            for (let i = 0; i < selectedInbox.tables[0].columns.length; i++) {
                let colName = selectedInbox.tables[0].columns[i].columnName
                newFieldList.push({ id: colName, value: colName })
            }
        }
        setFieldList(newFieldList)
    }, [selectedInbox])

    async function getFilter() {
        setFilterResult(null)
        setIsLoading(true)
        let jsonBody = {
            action: 'generateAIFilter',
            prompt: filterPrompt,
            inboxID: selectedInbox.inboxID,
        }
        await server.sheetPostData(jsonBody, (result) => {
            setFilterResult(result)
            setIsLoading(false)
        })
    }

    const handleSaveFilter = () => {
        saveFilter({
            filterName: filterName,
            filter: filterResult.filter,
            onSuccess: (workspaceMetadata) => {
                const newFilter = workspaceMetadata.filters.find(
                    (f) => f.filterName === filterName.trim()
                )
                setDialogSelectedFilters([...dialogSelectedFilters, newFilter.savedFilterKey])
                setAIFiltersDialogOpen(false)
            },
        })
    }

    let valid = filterResult && filterName && filterResult.filter && filterName.length > 0

    return (
        <ScoopDialog
            maxWidth="lg"
            open={AIFiltersDialogOpen}
            title={title}
            onClose={() => setAIFiltersDialogOpen(false)}
            actions={
                <>
                    <ScoopButton
                        variant="grey"
                        size="sm"
                        onClick={() => {
                            setAIFiltersDialogOpen(false)
                        }}
                    >
                        Cancel
                    </ScoopButton>
                    <ScoopButton
                        variant="default"
                        size="sm"
                        disabled={!valid || saveFilterPending}
                        loading={saveFilterPending}
                        onClick={handleSaveFilter}
                    >
                        Save
                    </ScoopButton>
                </>
            }
        >
            <div className={styles.dialogContent}>
                <div className={styles.formContainer}>
                    <div>
                        <p className={`${styles.fieldLabel} inter`}>Filter name</p>
                        <ScoopTextField
                            value={filterName}
                            onChange={(e) => {
                                setFilterName(e.target.value)
                            }}
                            placeholder="Enter filter name"
                        />
                    </div>
                    <div>
                        <p className={`${styles.fieldLabel} inter`}>Columns in your dataset</p>
                        {fieldList && fieldList.map((field) => field.value).join(', ')}
                    </div>
                    <div>
                        <p className={`${styles.fieldLabel} inter`}>Type your prompt here</p>
                        <ScoopTextField
                            value={filterPrompt}
                            onChange={(e) => setFilterPrompt(e.target.value)}
                            multiline
                            rows={2}
                            placeholder={'Start typing the prompt for your filter here...'}
                            padding={'0'}
                        />
                    </div>
                    <ScoopButton
                        variant="default"
                        size="sm"
                        onClick={() => {
                            getFilter()
                        }}
                        disabled={!filterPrompt || filterPrompt.length === 0 || isLoading}
                    >
                        {isLoading ? 'Generating...' : 'Generate Filter'}
                    </ScoopButton>
                    {filterResult && (
                        <div className={styles.resultContainer}>
                            <p className={`${styles.fieldLabel} inter`}>
                                Your filter has been validated, below is a description. Click 'Save'
                                to create
                            </p>
                            {filterResult.description}
                        </div>
                    )}
                </div>
            </div>
        </ScoopDialog>
    )
}
